// extracted by mini-css-extract-plugin
export default {"avatarContainer":"Avatar_avatarContainer__+Dvbw","svg":"Avatar_svg__XqfLx","avatarDefault":"Avatar_avatarDefault__6ZjD3"};